import i18n from '../i18n.js';
export class PreviewComparison {
  constructor(container) { this.container = container; this.render(); }
  render() {
    this.container.innerHTML =
      '<div class="preview-comparison" id="preview-comparison">' +
      '<h3>' + i18n.t('preview.title') + '</h3>' +
      '<div class="preview-images">' +
      '<div class="preview-image-box"><img id="preview-before" src="" alt="' + i18n.t('preview.before') + '"><div class="preview-image-label">' + i18n.t('preview.before') + ' <span>(' + i18n.t('preview.original') + ')</span></div></div>' +
      '<div class="preview-image-box"><img id="preview-after" src="" alt="' + i18n.t('preview.after') + '"><div class="preview-image-label">' + i18n.t('preview.after') + '</div></div>' +
      '</div></div>';
    this.element = this.container.querySelector('#preview-comparison');
    this.beforeImg = this.container.querySelector('#preview-before');
    this.afterImg = this.container.querySelector('#preview-after');
  }
  showBefore(im) { this.beforeImg.src = URL.createObjectURL(im.originalBlob); }
  showAfter(blobUrl) { this.afterImg.classList.remove('loading'); this.afterImg.src = blobUrl; this.element.classList.add('visible'); }
  showLoading() {
    this.afterImg.classList.add('loading');
    this.afterImg.src = '';
    this.afterImg.alt = i18n.t('preview.generating');
    this.element.classList.add('visible');
  }
  hide() { this.element.classList.remove('visible'); this.beforeImg.src = ''; this.afterImg.src = ''; this.afterImg.classList.remove('loading'); }
  updateI18n() {
    var h = this.element.querySelector('h3'); if (h) h.textContent = i18n.t('preview.title');
    var ls = this.element.querySelectorAll('.preview-image-label');
    if (ls[0]) { var sp = ls[0].querySelector('span'); ls[0].childNodes[0].textContent = i18n.t('preview.before') + ' '; if (sp) sp.textContent = '(' + i18n.t('preview.original') + ')'; }
    if (ls[1]) ls[1].textContent = i18n.t('preview.after');
  }
}
